export const getDigiLifeLoanProtection = (state) =>
  state.digiLifeLoanProtection;
